module.exports = __webpack_public_path__ + "img/fav.3c74a9d3.png";